import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace CPESpeedway {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: false,
      inputs: [
        {
          type: "checkbox",
          label: Constants.dog_class_element.speedway,
          multiSelect: false,
          options: [
            {
              value: Constants.dog_class_element.speedway,
              id: Constants.dog_class_element.speedway,
            },
          ],
        },
      ],
    },
  ];
}
